export const notification = (title: string, message: string, callback: () => void = () => {}) => {
  const notification = new Notification(title, { body: message, icon: `${process.env.PUBLIC_URL}/favicon.ico` });
  notification.onclick = callback;
};
